<template>
  <div>
    <b-modal v-model="showModal"
      title="Datos del registro"
      header-bg-variant="secondary"
      header-text-variant="white"
      scrollable
      @close="close"
      @show="getRecord"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      size="lg">
      <div><span><b>Código:</b> {{ record.code }}</span></div>
      <div><span><b>Módulo:</b> {{ record.coursename }}</span></div>
      <div><span><b>Módulo:</b> {{ record.modulename }}</span></div>
      <div><span><b>Tema:</b> {{ record.topic }}</span></div>
      <div><span><b>Descripción:</b> <div v-html="record.description"></div></span></div>
      <div><span><b>Estado:</b> {{ record.status === 1 ? 'Activo' : 'Inactivo' }}</span></div>
      <hr v-if="record.image">
      <div v-if="record.image">
        <span><b>Imagen:</b></span>
      </div>
      <div v-if="record.image" class="container">
        <div class="row p-2 m-1" style="background-color: #efefef; border-radius: 10px;">
          <div class="col-12 text-center">
            <img :src="record.path" alt="" width="70%">

          </div>
        </div>
      </div>
      <!-- {{ record.id }} -->
        <!-- Desea cambiar el estado del registo <strong>{{ codeRecord }}</strong>? -->
        <div class="modal-footer">
          <button class="btn btn-sm btn-danger" type="button" @click="close"> <i class="fas fa-times fa-fw"></i>Cerrar</button>
          <!-- <button @click="submit" class="btn btn-sm btn-success"> <i class="fas fa-download fa-fw"></i>Aceptar</button> -->
        </div>
    </b-modal>
  </div>
</template>

<script>
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { BModal } from 'bootstrap-vue';

export default {
  components: {BModal},
  props: ['record', 'showModal'],
  data() {
    return {
      form: {},
      loading: false,
      dataRecord: [],
    }
  },
  methods:{
    close(bvModalEvent) {
      this.$emit('update:showModal', false)
      // this.$emit('getRecords');
      // bvModalEvent.preventDefault()
    },
    getRecord() {
      this.loading = true
      this.form = {
        id: this.id
      }
    },
  }
}

</script>